import { Component, ComponentInterface, h, VNode } from '@stencil/core';

import { UniHostTemplate } from '@uiwebkit/common';
import { uniWatermark } from '@uni/license';

@Component({
  tag: 'uni-sidebar',
  styleUrl: '../styles/sidebar.css',
})
export class UniSidebarComponent implements ComponentInterface {

  render(): VNode {
    const classes = { 'uni-sidebar': true };

    return UniHostTemplate({ classes }, <slot />);
  }

  componentDidLoad(): void {
    uniWatermark('pro');
  }
}
